import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import RetailContent from './RetailContent';

const styles = theme => ({
  directBuyContainer: {
    marginTop: '80px',
    marginBottom: '80px'
  }
});

class DirectBuy extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <div>
        <RetailContent id={1} title="manufacturer" markup={2} />
        <div className={`${classes.directBuyContainer}`}>
          <RetailContent id={2} title="directbuy" markup={1} />
        </div>
        <RetailContent id={3} title="arrival in your home" markup={null} />
      </div>
    );
  }
}

export default withStyles(styles)(DirectBuy);
